import { render } from "./AttributionBlock.vue?vue&type=template&id=86aeba4c&scoped=true"
const script = {}

import "./AttributionBlock.vue?vue&type=style&index=0&id=86aeba4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86aeba4c"]])

export default __exports__